import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import ErrorBoundary from "@/components/ErrorBoundary";

// Suppress specific console errors from third-party scripts
// WITHOUT patching DOM methods (which breaks React)
if (typeof window !== 'undefined') {
  const originalError = console.error;
  console.error = (...args) => {
    const message = args[0]?.toString() || '';
    // Suppress DOM manipulation errors from third-party scripts
    if (
      message.includes('removeChild') ||
      message.includes('insertBefore') ||
      message.includes('NotFoundError') ||
      message.includes('appendChild') ||
      message.includes('not a child')
    ) {
      // Log it as warning instead of error
      console.warn('[Suppressed DOM Error]', message.substring(0, 100));
      return;
    }
    originalError.apply(console, args);
  };

  // Catch unhandled errors silently
  window.addEventListener('error', (event) => {
    const message = event.message || '';
    if (
      message.includes('removeChild') ||
      message.includes('insertBefore') ||
      message.includes('NotFoundError') ||
      message.includes('appendChild')
    ) {
      console.warn('[Suppressed Window Error]', message.substring(0, 100));
      event.preventDefault();
      return false;
    }
  }, true);
}

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('SW registered: ', registration);
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
